function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var FlightLeft = function FlightLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M12.935 21.5h.844l-2.261-6.784a1 1 0 0 1 .948-1.317h5.836c.265 0 .52.106.707.293l1.478 1.479h.243l-.64-2.5a1.8 1.8 0 0 1 0-.842l.64-2.5h-.243l-1.478 1.478a1 1 0 0 1-.707.293h-5.836a1 1 0 0 1-.948-1.316L13.778 3h-.843l-4.26 7.579c-.177.314-.511.51-.872.51H4.288c-1.056 0-1.255.759-1.292 1.086l.004.248c.033.229.232.988 1.288.988h3.515a1 1 0 0 1 .872.51zm2.23 2H12.35a1 1 0 0 1-.872-.51l-4.26-7.579h-2.93c-2.23 0-3.186-1.737-3.284-2.904L1 12.077c.102-1.251 1.058-2.988 3.288-2.988h2.93l4.26-7.579A1 1 0 0 1 12.35 1h2.816a1 1 0 0 1 .949 1.316L13.853 9.1h4.035l1.478-1.478a1 1 0 0 1 .707-.293h1.945a1 1 0 0 1 .969 1.248l-.94 3.673.94 3.673a1.003 1.003 0 0 1-.97 1.248h-1.944c-.265 0-.52-.106-.707-.293l-1.478-1.479h-4.035l2.262 6.784a1 1 0 0 1-.95 1.317"
  }));
};
export default FlightLeft;